import React, { useState, useEffect } from 'react'
import Snackbar from '@material-ui/core/Snackbar'
import MuiAlert from '@material-ui/lab/Alert'
import { remove } from 'local-storage'
import { useUserDispatcher } from '@hooks'
import Videos from './localComponents/ListVideo'

import VideoDialog from './localComponents/ViewVideo'
import EditVideoDialog from './localComponents/EditVideo'
import { getVideoMaterials } from '../../services/restAPI/videoMaterial/videoMaterialService'

function Alert(props: any) {
  return <MuiAlert elevation={6} variant="filled" {...props} />
}

const ListVideo: React.FC = () => {
  const { clearUserAuthData } = useUserDispatcher()
  const [openPreviewDialog, setOpenPreviewDialog] = useState(false)
  const [openEditVideoDialog, setOpenEditVideoDialog] = useState(false)
  const [targetVideoURL, setTargetVideoURL] = useState('')
  const [targetVideo, setTargetVideo] = useState(null)
  const [openSnackBar, setOpenSnackbar] = useState(false)
  const [targetVideoName, setTargetVideoName] = useState('')
  const [datas, setDatas] = useState<any[]>([])

  const [filter, setFilter] = useState(null)
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('calories')
  const [sortBy, setSortBy] = useState(null)

  const goToLogin = () => {
    remove('token')
    clearUserAuthData()
  }

  const populateVideoMaterials = async (filter = null, sortBy = null) => {
    getVideoMaterials()
    .then(videoMaterials => {
      setDatas(videoMaterials)
    })
    .catch(err => {
      if (err.message == "authorization") {
        goToLogin()
      }
    })
  }

  useEffect(() => {
    populateVideoMaterials()
  }, [])

  const handleVideoClick = (name: string, videoURL: string) => {
    setTargetVideoURL(videoURL)
    setTargetVideoName(name)
    setOpenPreviewDialog(true)
  }

  const handlePreviewDialogClose = () => {
    setTargetVideoURL('')
    setTargetVideoName('')
    setOpenPreviewDialog(false)
  }

  const handleEditVideo = (vid: any) => {
    setTargetVideo(vid)
    setOpenEditVideoDialog(true)
  }

  const handleEditVideoClose = (refresh = false) => {
    if (refresh) {
      setOpenSnackbar(true)
      populateVideoMaterials(filter, sortBy)
    }
    setOpenEditVideoDialog(false)
  }

  const handleOnCloseSnackbar = () => {
    setOpenSnackbar(false)
  }

  return <div>
    {openPreviewDialog && <VideoDialog open={openPreviewDialog} name={targetVideoName} handleClose={handlePreviewDialogClose} videoURL={targetVideoURL} />}
    {openEditVideoDialog && <EditVideoDialog open={openEditVideoDialog} data={targetVideo} handleClose={handleEditVideoClose} />}
    <Snackbar open={openSnackBar} onClose={handleOnCloseSnackbar} autoHideDuration={6000}>
      <Alert onClose={handleOnCloseSnackbar} severity="success">
        Video(s) have successfully updated!
      </Alert>
    </Snackbar>
    <Videos order={order} setOrder={setOrder} orderBy={orderBy} setOrderBy={setOrderBy} populateVideoMaterials={populateVideoMaterials} filter={filter} setFilter={setFilter} sortBy={sortBy} setSortBy={setSortBy} videos={datas} handleEditVideo={handleEditVideo} handleVideoClick={handleVideoClick} />
  </div>
}

export default ListVideo